var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariant4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#fff",
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m34.493 14.083.117-.693-.693.117-16.097 2.719-.158.026-.113.113c-3.861 3.862-4.074 9.987-.53 13.909l-3.372 3.372.707.707 3.372-3.372c3.922 3.544 10.047 3.33 13.909-.532l.112-.113.027-.157 2.72-16.096Zm-16.059 16.19c3.477 3.104 8.888 2.961 12.381-.42L33.39 14.61l-15.244 2.575c-3.381 3.493-3.523 8.903-.419 12.38l6.92-6.919.707.707-6.92 6.92Z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 13.646,
    y1: 23.872,
    x2: 34.61,
    y2: 23.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariant4);
export default __webpack_public_path__ + "static/media/variant4.a967d1c3055e1e96dfb1683193604458.svg";
export { ForwardRef as ReactComponent };